import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import { Cta } from "@components/common/cta/Cta"
import { TextInput } from "@components/common/form/TextInput"

import { EmailSignUpInterface } from "./EmailSignUp.interface"
import * as s from "./EmailSignUp.module.scss"

import axios from "axios"

export const EmailSignup = ({ data }: EmailSignUpInterface) => {
  const [isClient, setClient] = useState(false)
  const key = isClient ? "client" : "server"

  useEffect(() => {
    setClient(true)
  }, [])

  const { title, blurb } = data
  const [isTyping, setIsTyping] = useState(false)
  const [sending, setSending] = useState(false)
  /*eslint-disable*/
  const [sendError, setSendError] = useState(false)
  /*eslint-enable*/
  const [sent, setSent] = useState(false)
  const [formValue, setFormValue] = useState({
    emailAddress: {
      value: "",
      required: true,
      pattern:
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      errored: false,
    },
  })

  const submitEntry = async () => {
    if (sending) return
    setSending(true)
    setSendError(false)
    let hasError = false

    const _formVal = { ...formValue }

    Object.keys(_formVal).forEach(function (item) {
      const field = _formVal[item]
      if (field.required && !field.value) {
        hasError = true
        _formVal[item].errored = true
      } else {
        _formVal[item].errored = false
      }

      if (field.required && field.pattern) {
        if (!field.pattern.test(String(field.value).toLowerCase())) {
          hasError = true

          _formVal[item].errored = true
        } else {
          _formVal[item].errored = false
        }
      }
    })
    setFormValue(_formVal)

    if (hasError) {
      setSending(false)
    } else {
      //SEND

      const values = []

      Object.keys(formValue).forEach(function (item) {
        values.push(item, formValue[item].value)
      })

      axios
        .request({
          method: "POST",
          url: "/.netlify/functions/klaviyo-newsletter",
          data: {
            email: values[1],
          },
        })
        .then(function (response) {
          console.log(response.data)
          setSent(true)
          setSending(false)
        })
        .catch(function (error) {
          console.log(error)
          setSendError(true)
          setSending(false)
        })
    }
  }

  if (!isClient) return null

  return (
    <div className={s.emailSignUp} key={key}>
      <div className={s.emailSignUp__inner}>
        {!sent ? (
          <div className={s.emailSignUp__inner___inputWrapper}>
            <h3>{title}</h3>
            <p className={s.emailSignUp__blurb}>{blurb}</p>
            <span className={s.emailSignUp__innerInputError}>
              {formValue.emailAddress.errored &&
                "Please enter a valid email address"}
            </span>
            <TextInput
              error={formValue.emailAddress.errored}
              value={formValue.emailAddress.value}
              onChange={e => {
                if (formValue["emailAddress"]) {
                  setIsTyping(true)
                }
                setFormValue({
                  ...formValue,
                  emailAddress: {
                    ...formValue["emailAddress"],
                    value: e.target.value,
                  },
                })
              }}
              className={s.emailSignUp__innerInput}
              solidPlaceholder="Email address"
            />
            <div
              className={`${
                !isTyping ? s.emailSignUp__inner__permissionHidden : ""
              } ${s.emailSignUp__inner__permission}`}
            >
              <p className={s.emailSignUp__tac}>
                Your personal data will be processed in line with our{" "}
                <Link to="/privacy-policy">Privacy Notice</Link>.
              </p>
              <Cta
                className={s.emailSignUp__innerCta}
                title="Submit"
                onClick={submitEntry}
              />
            </div>
          </div>
        ) : (
          <div className={s.emailSignUp__inner___inputWrapper}>
            <h3>{title}</h3>
            <p className={s.emailSignUp__blurb}>
              Thanks for signing up! You will receive a confirmation email
              shortly.
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
